export enum SozlesmeTuru {
    yazili = "yazili",
    sozlu = "sozlu",
    noter = "noter",
}
export enum SozlesmeTuruLabel {
    yazili = "Yazılı",
    sozlu = "Sözlü",
    noter = "Noter",
}